$(document).ready(function () {
  var $emailInput = $('section.clNewsletter #email');
  var $emailWrapper = $emailInput.closest('section.clNewsletter .email');
  var $newsletterContent = $('section.clNewsletter .newsletterContent');
  $emailInput.on('focus', function () {
    $emailWrapper.addClass('active');
    $newsletterContent.stop(true, true).slideDown();
  });
  $emailInput.on('blur', function () {
    if ($emailInput.val().trim() === '') {
      $emailWrapper.removeClass('active');
    }
  });
  $('section.clNewsletter .newsletterContent .gender label input[type="checkbox"]').change(function () {
    var $inputBox = $(this).closest('.inputBox');
    
    if ($(this).is(':checked')) {
      $inputBox.addClass('active');
    } else {
      $inputBox.removeClass('active');
    }
  });
});

$(document).ready(function () {
  var $form = $('.clNewsletter form[action*="/contact"]');
  var $email = $form.find('section.clNewsletter #email');
  var $errorEmail = $form.find('section.clNewsletter .errorEmail');
  var $checkboxes = $form.find('section.clNewsletter input[type="checkbox"]');
  var $errorCheckbox = $form.find('section.clNewsletter .errorCheckbox');

  $errorEmail.hide();
  $errorCheckbox.hide();

  $form.on('submit', function (e) {
    var isValid = true;

    // Email validation
    var emailVal = $email.val().trim();
    if (emailVal === '') {
      $errorEmail.show();
      $email.focus();
      isValid = false;
    } else {
      $errorEmail.hide();
    }

    // Checkbox validation
    var isAnyChecked = $checkboxes.is(':checked');
    if (!isAnyChecked) {
      $errorCheckbox.show();
      if (isValid) $checkboxes.first().focus();
      isValid = false;
    } else {
      $errorCheckbox.hide();
    }

    if (!isValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
    } else {
      // Delay to let the form submit, then clear email
      setTimeout(function () {
        $email.val('');
      }, 100);
    }
  });
});
function toggleIcon(input) {
  const icon = input.nextElementSibling;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  if (!input.value) {
    icon.style.display = 'none';
    return;
  }

  icon.style.display = emailRegex.test(input.value) ? 'block' : 'none';
}

// Form Newsletter

// document.addEventListener('DOMContentLoaded', function(){
//   const form = document.querySelector('.newsletter_form');
//   const emailInput = form.querySelector('#email');
//   const emailError = form.querySelector('span.newsletter__email-error');
//   const checkboxes = form.querySelectorAll('form.newsletter_form .gender input[type="checkbox"]');
//   const collectionsError = form.querySelector('span.newsletter__collections-error');
//   const newsletterSuccess = document.querySelector('.newsletter-sp');
//   const submitBtn = form.querySelector('input[type="submit"]');
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   const newsletterSP = document.querySelector('.newsletter-sp');
//   const newsletterSuccessTwo = form.querySelector('.thankYouContent');

//   // Store Form Attributes
//   const originalAttrs = {};
//   [...form.attributes].forEach(attr => {
//     originalAttrs[attr.name] = attr.value;
//   });

//   // Remove Form Attributes
//   function removeFormAttrs(){
//     [...form.attributes].forEach(attr => {
//       if(attr.name !== 'class' && attr.name !== 'id'){
//           form.removeAttribute(attr.name);
//       }
//     });
//   }

//   // Restore Form Attributes
//   function restoreFormAttrs(){
//     Object.keys(originalAttrs).forEach(name => {
//       if(name !== 'class' && name !== 'id'){
//         form.setAttribute(name, originalAttrs[name]);
//       }
//     });
//   }  

//   // Email Conditions
//   function emailConditions(){
//     const email = emailInput.value.trim();
//     if(emailInput.value == ''){
//       emailError.innerText = 'Sorry, email address is mandatory.';
//       emailError.style.display = 'block';
//       return false;
//     }else if(!emailRegex.test(email)){
//       emailError.innerText = 'Please enter a valid email address (Ex: johndoe@domain.com).';
//       emailError.style.display = 'block';
//       return false;
//     }else{
//       emailError.style.display = 'none';
//       return true;
//     }
//   }

//   // Checkbox Conditions
//   function checkboxConditions(){
//     if(![...checkboxes].some(cb => cb.checked)){
//       collectionsError.style.display = 'block';
//       return false;
//     }else{
//       collectionsError.style.display = 'none';
//       return true;
//     }
//   }

//   // Toggle Form Attributes
//   function toggleFormAttrs(){
//     if(emailConditions() && checkboxConditions()){
//       restoreFormAttrs();
//     }else{
//       removeFormAttrs();
//     }
//   }

//   // Email Input
//   emailInput.addEventListener('input', function(){
//     emailError.style.display = 'none';
//     newsletterSuccessTwo.style.display = 'none';
//   })
  
//   // checkbox Input
//   checkboxes.forEach(box => {
//     box.addEventListener('change', function(){
//       collectionsError.style.display = 'none';
//       newsletterSuccessTwo.style.display = 'none';
//     });
//   });

//   // After Page reload Show Popup
//   if (localStorage.getItem('newsletterSubmitted') === 'true') {
//     newsletterSP.classList.add('show');

//     setTimeout(() => {
//       newsletterSP.classList.remove('show');
//       localStorage.removeItem('newsletterSubmitted');
//     }, 5000);
//   }

//   // Form Submit
//   form.addEventListener('submit', function(e){
//     emailConditions();
//     checkboxConditions();
//     if(!emailConditions() || !checkboxConditions()){
//       e.preventDefault();
//       removeFormAttrs();
//     }else{
//       restoreFormAttrs();
//       emailInput.focus();
//       localStorage.setItem('newsletterSubmitted', 'true');
//     }
//   })

//   removeFormAttrs();
// });
document.addEventListener('DOMContentLoaded', function(){
  const form = document.querySelector('.newsletter_form');
  const emailInput = form.querySelector('#email');
  const emailError = form.querySelector('span.newsletter__email-error');
  const checkboxes = form.querySelectorAll('form.newsletter_form .gender input[type="checkbox"]');
  const collectionsError = form.querySelector('span.newsletter__collections-error');
  const newsletterSuccess = document.querySelector('.newsletter-sp');
  const submitBtn = form.querySelector('input[type="submit"]');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const newsletterSP = document.querySelector('.newsletter-sp');
  const newsletterSuccessTwo = form.querySelector('.thankYouContent');
  
  // Store Form Attributes
  const originalAttrs = {};
  [...form.attributes].forEach(attr => {
    originalAttrs[attr.name] = attr.value;
  });
  
  // Remove Form Attributes
  function removeFormAttrs(){
    [...form.attributes].forEach(attr => {
      if(attr.name !== 'class' && attr.name !== 'id'){
          form.removeAttribute(attr.name);
      }
    });
  }
  
  // Restore Form Attributes
  function restoreFormAttrs(){
    Object.keys(originalAttrs).forEach(name => {
      if(name !== 'class' && name !== 'id'){
        form.setAttribute(name, originalAttrs[name]);
      }
    });
  }  
  
  // Email Conditions
  function emailConditions(){
    const email = emailInput.value.trim();
    if(emailInput.value == ''){
      emailError.innerText = 'Sorry, email address is mandatory.';
      emailError.style.display = 'block';
      return false;
    }else if(!emailRegex.test(email)){
      emailError.innerText = 'Please enter a valid email address (Ex: johndoe@domain.com).';
      emailError.style.display = 'block';
      return false;
    }else{
      emailError.style.display = 'none';
      return true;
    }
  }
  
  // Checkbox Conditions
  function checkboxConditions(){
    if(![...checkboxes].some(cb => cb.checked)){
      collectionsError.style.display = 'block';
      return false;
    }else{
      collectionsError.style.display = 'none';
      return true;
    }
  }
  
  // Toggle Form Attributes
  function toggleFormAttrs(){
    if(emailConditions() && checkboxConditions()){
      restoreFormAttrs();
    }else{
      removeFormAttrs();
    }
  }
  
  // Email Input
  emailInput.addEventListener('input', function(){
    emailError.style.display = 'none';
    newsletterSuccessTwo.style.display = 'none';
  })
  
  // checkbox Input
  checkboxes.forEach(box => {
    box.addEventListener('change', function(){
      collectionsError.style.display = 'none';
      newsletterSuccessTwo.style.display = 'none';
    });
  });
  
  // After Page reload Show Popup with Email
  if (localStorage.getItem('newsletterSubmitted') === 'true') {
    const savedEmail = localStorage.getItem('submittedEmail');
    
    // Newsletter success ke andar p tag dhundo aur email display karo
    const successParagraph = newsletterSP.querySelector('p');
    if(successParagraph && savedEmail) {
      successParagraph.innerHTML = successParagraph.innerHTML + ' ' + savedEmail;
    }
    
    newsletterSP.classList.add('show');
    setTimeout(() => {
      newsletterSP.classList.remove('show');
      localStorage.removeItem('newsletterSubmitted');
      localStorage.removeItem('submittedEmail');
    }, 5000);
  }
  
  // Form Submit
  form.addEventListener('submit', function(e){
    emailConditions();
    checkboxConditions();
    if(!emailConditions() || !checkboxConditions()){
      e.preventDefault();
      removeFormAttrs();
    }else{
      restoreFormAttrs();
      emailInput.focus();
      // setTimeout(() => {
      //   const btn = this.querySelector('input[type="submit"]');
      //   if (btn) btn.click();
      // }, 500);      
      // Email save karo localStorage mein
      localStorage.setItem('submittedEmail', emailInput.value.trim());
      localStorage.setItem('newsletterSubmitted', 'true');
    }
  })
  
  removeFormAttrs();
});